export default __webpack_public_path__ + "static/media/indexMap.6cc4adba.png";